// Barracuda — chartes de languettes storefront (couleurs + libellés + modal de choix).
// MIROIR de apps/mobile/src/stripProfiles.ts. Chimie inchangée : la sélection utilise
// l'index (RULES.values), pas ces libellés.
// POUR RETIRER L'ANCIENNE CHARTE (~1 an) : enlever "original" de AVAIL → le modal n'affiche
// plus qu'une bouteille et le résumé se masque automatiquement.
(function () {
  "use strict";

  var P = {
    original: {
      name: "Charte originale",
      image: "https://cdn.shopify.com/s/files/1/0689/6323/8136/files/3B1692BB81BF3855EC8FB73F0CB5D4AC.jpg?v=1782019153&width=600",
      scales: {
        hardness: [["#5785AD", "0"], ["#6180AD", "100"], ["#6D79A8", "150"], ["#7573A2", "250"], ["#8565A0", "500"], ["#96609B", "1000"]],
        fc: [["#FFFFFF", "0"], ["#F5ECF3", "0.5"], ["#E9DAE8", "1"], ["#BD98C0", "3"], ["#AA80AD", "5"], ["#94599B", "10"]],
        br: [["#FFFFFF", "0"], ["#F5ECF3", "1"], ["#E9DAE8", "2"], ["#BD98C0", "6"], ["#AA80AD", "10"], ["#94599B", "20"]],
        tc: [["#FFF7AE", "0"], ["#EDEDA2", "0.5"], ["#DEE5A0", "1"], ["#BDD7A0", "3"], ["#9CC99F", "5"], ["#86C29E", "10"]],
        cya: [["#F2B17F", "0"], ["#EDB3A3", "30–50"], ["#ECB2B0", "100"], ["#E8A3A7", "150"], ["#CDA1B0", "240"]],
        alk: [["#FFF9C6", "0"], ["#DDEAD5", "40"], ["#C3DFD3", "80"], ["#ADD7DA", "120"], ["#9BD1E0", "180"], ["#8ECEE8", "240"]],
        ph: [["#F8BE56", "6.6"], ["#EFB56B", "6.8"], ["#EBA76B", "7.2"], ["#E79A69", "7.8"], ["#E48F72", "8.2"], ["#E18379", "9.0"]]
      }
    },
    updated: {
      name: "Nouvelle charte",
      image: "https://cdn.shopify.com/s/files/1/0689/6323/8136/files/IMG-1540.png?v=1784673041&width=600",
      scales: {
        hardness: [["#4D7EAA", "0"], ["#5674A7", "100"], ["#626BA3", "150"], ["#6D609D", "250"], ["#78549A", "500"], ["#8A4B96", "1000"]],
        fc: [["#FFFFFF", "0"], ["#F5EDF4", "0.5"], ["#E7D7E6", "1"], ["#C69AC4", "3"], ["#AC72B1", "5"], ["#97429E", "10"]],
        br: [["#FFFFFF", "0"], ["#F5EDF4", "1"], ["#E7D7E6", "2"], ["#C69AC4", "6"], ["#AC72B1", "10"], ["#97429E", "20"]],
        tc: [["#ECEC52", "0"], ["#D5DF4D", "0.5"], ["#B7D64B", "1"], ["#84BE55", "3"], ["#65AE5A", "5"], ["#52A960", "10"]],
        cya: [["#D99A55", "0"], ["#D98B72", "30–50"], ["#D4857E", "100"], ["#CF727C", "150"], ["#B3778D", "240"]],
        alk: [["#E6E45F", "0"], ["#BCD69B", "40"], ["#9CC7A4", "80"], ["#79BDB9", "120"], ["#60B0B9", "180"], ["#4DA7BD", "240"]],
        ph: [["#DC9638", "6.6"], ["#DB9136", "6.8"], ["#D9753D", "7.2"], ["#D2604D", "7.8"], ["#CF4F55", "8.2"], ["#D32663", "9.0"]]
      }
    }
  };
  var AVAIL = ["updated", "original"], DEF = "updated", KEY = "barracuda_strip_profile";
  var current = DEF, pending = DEF;

  function stored() { try { var v = localStorage.getItem(KEY); if (AVAIL.indexOf(v) >= 0) return v; } catch (e) {} return null; }

  // ── Repeinture des couleurs + libellés depuis le profil actif ──
  function apply(id) {
    var prof = P[id] || P[DEF];
    Object.keys(prof.scales).forEach(function (param) {
      var scale = prof.scales[param];
      var blocks = document.querySelectorAll('.bsa__param[data-param="' + param + '"]');
      for (var b = 0; b < blocks.length; b++) {
        var blk = blocks[b];
        for (var i = 0; i < scale.length; i++) {
          var box = blk.querySelector('.bsa__box[data-value="' + i + '"]');
          if (box) box.style.background = scale[i][0];
        }
        var spans = blk.querySelectorAll('.bsa__labels span');
        if (spans.length) { for (var k = 0; k < scale.length; k++) { if (spans[k * 2]) spans[k * 2].textContent = scale[k][1]; } }
      }
    });
  }

  // ── Styles injectés une fois ──
  function injectStyle() {
    if (document.getElementById('bsaStripStyle')) return;
    var css = ''
      + '.bsa__stripChip{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin:0 0 14px;padding:10px 12px;background:#fff;border:1px solid rgba(20,45,75,.08);border-radius:14px;box-shadow:0 6px 18px rgba(20,35,70,.05)}'
      + '.bsa__stripChip .lbl{font-weight:800;color:#1f405c;font-size:13px}'
      + '.bsa__stripChip .val{font-weight:800;color:#214A75;font-size:13px}'
      + '.bsa__stripChip .mod{margin-left:auto;cursor:pointer;border:2px solid #214A75;background:#eaf1f8;color:#214A75;font-weight:800;font-size:13px;border-radius:999px;padding:6px 14px;line-height:1}'
      + '.bsa__stripOv{position:fixed;inset:0;background:rgba(15,23,42,.55);display:none;align-items:center;justify-content:center;padding:20px;z-index:99999}'
      + '.bsa__stripOv.open{display:flex}'
      + '.bsa__stripCard{width:100%;max-width:460px;background:#fff;border-radius:22px;padding:22px;box-shadow:0 24px 60px rgba(2,6,23,.3)}'
      + '.bsa__stripCard h3{margin:0 0 4px;font-size:20px;font-weight:900;color:#1f405c;text-align:center}'
      + '.bsa__stripCard p{margin:0 0 16px;font-size:13px;color:#64748b;text-align:center}'
      + '.bsa__stripGrid{display:flex;gap:12px}'
      + '.bsa__bottle{flex:1;cursor:pointer;background:#F5F7FA;border:2px solid transparent;border-radius:16px;padding:12px;text-align:center;position:relative}'
      + '.bsa__bottle[aria-pressed="true"]{border-color:#214A75;background:#eaf1f8}'
      + '.bsa__bottle img{width:100%;height:150px;object-fit:contain;border-radius:10px;background:#fff}'
      + '.bsa__bottle span{display:block;margin-top:8px;font-weight:800;font-size:13px;color:#1f405c}'
      + '.bsa__bottle[aria-pressed="true"] span{color:#214A75}'
      + '.bsa__bottleTick{position:absolute;top:8px;right:8px;width:22px;height:22px;border-radius:999px;background:#214A75;color:#fff;display:none;align-items:center;justify-content:center;font-size:14px;font-weight:900}'
      + '.bsa__bottle[aria-pressed="true"] .bsa__bottleTick{display:flex}'
      + '.bsa__stripConfirm{margin-top:18px;width:100%;cursor:pointer;border:none;background:#1f405c;color:#fff;font-weight:900;font-size:16px;border-radius:999px;padding:14px}';
    var st = document.createElement('style'); st.id = 'bsaStripStyle'; st.textContent = css;
    document.head.appendChild(st);
  }

  var chipEl, ovEl;

  function updateChip() {
    if (!chipEl) return;
    var v = chipEl.querySelector('.val'); if (v) v.textContent = P[current].name;
  }

  function highlight() {
    if (!ovEl) return;
    var cards = ovEl.querySelectorAll('.bsa__bottle');
    for (var i = 0; i < cards.length; i++) { cards[i].setAttribute('aria-pressed', cards[i].getAttribute('data-profile') === pending ? 'true' : 'false'); }
  }

  function openModal() { pending = current; highlight(); if (ovEl) ovEl.classList.add('open'); }
  function closeModal() { if (ovEl) ovEl.classList.remove('open'); }
  function confirmChoice() {
    if (AVAIL.indexOf(pending) < 0) pending = DEF;
    current = pending;
    try { localStorage.setItem(KEY, current); } catch (e) {}
    apply(current); updateChip(); closeModal();
  }

  function buildChip() {
    var mount = document.querySelector('.bsa__stripMount');
    if (!mount) return;
    chipEl = document.createElement('div');
    chipEl.className = 'bsa__stripChip';
    chipEl.innerHTML = '<span class="lbl">Languettes utilisées :</span><span class="val"></span><button type="button" class="mod">Modifier</button>';
    mount.appendChild(chipEl);
    chipEl.querySelector('.mod').addEventListener('click', openModal);
    updateChip();
  }

  function buildModal() {
    ovEl = document.createElement('div');
    ovEl.className = 'bsa__stripOv';
    ovEl.setAttribute('role', 'dialog');
    ovEl.setAttribute('aria-modal', 'true');
    ovEl.setAttribute('aria-label', 'Choix de la charte de languettes');
    var cards = '';
    for (var i = 0; i < AVAIL.length; i++) {
      var id = AVAIL[i], prof = P[id];
      cards += '<button type="button" class="bsa__bottle" data-profile="' + id + '" aria-pressed="false">'
        + '<span class="bsa__bottleTick">✓</span>'
        + '<img src="' + prof.image + '" alt="Languettes – ' + prof.name + '">'
        + '<span>' + prof.name + '</span></button>';
    }
    ovEl.innerHTML = '<div class="bsa__stripCard">'
      + '<h3>Quelles languettes utilisez-vous?</h3>'
      + '<p>Sélectionnez votre bouteille pour que les couleurs affichées correspondent à votre charte.</p>'
      + '<div class="bsa__stripGrid">' + cards + '</div>'
      + '<button type="button" class="bsa__stripConfirm">Confirmer</button></div>';
    document.body.appendChild(ovEl);
    var btns = ovEl.querySelectorAll('.bsa__bottle');
    for (var j = 0; j < btns.length; j++) { (function (b) { b.addEventListener('click', function () { pending = b.getAttribute('data-profile'); highlight(); }); })(btns[j]); }
    ovEl.querySelector('.bsa__stripConfirm').addEventListener('click', confirmChoice);
    ovEl.addEventListener('click', function (e) { if (e.target === ovEl) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  }

  function init() {
    injectStyle();
    buildChip();
    if (AVAIL.length >= 2) buildModal(); // pas de modal s'il ne reste qu'une charte
    var s = stored();
    current = s || DEF;
    apply(current); updateChip();
    // Premier passage (aucun choix mémorisé) → on impose le choix via le modal.
    if (!s && ovEl) openModal();
    // Ré-applique sur la bandelette clonée du simulateur.
    try {
      var root = document.querySelector('.bsa') || document.body;
      var mo = new MutationObserver(function (muts) {
        for (var m = 0; m < muts.length; m++) { var a = muts[m].addedNodes; for (var j = 0; j < a.length; j++) { var n = a[j];
          if (n.nodeType === 1 && ((n.classList && n.classList.contains('bsa__box')) || (n.querySelector && n.querySelector('.bsa__box')))) { apply(current); return; } } }
      });
      mo.observe(root, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
